import type { ReactNode } from 'react'

import {
  AuthProvider as SharedAuthProvider,
  useAuth as useSharedAuth,
  type AuthState as SharedAuthState,
} from '@curri/portal-auth'

import type { Caller, PortalConfig } from '../types.ts'

// The portal's binding of `@curri/portal-auth`, which owns the OAuth session
// itself: the PKCE redirect legs, the in-memory access token, the single silent
// refresh, and the fetch wrapper. Only what differs per SPA lives here, plus the
// portal's caller and config types, pinned once so screens call `useAuth()` bare.

/** The partner surface resolves the caller from the REST API's own endpoint. */
const CALLER_PATH = '/api/me'

/** The portal is served from the origin root, so it redirects back to it. */
const REDIRECT_PATH = '/'

export { CURRI_VERSION } from '@curri/portal-auth'

export type AuthState = SharedAuthState<Caller>

export const AuthProvider = ({
  config,
  children,
}: {
  config: PortalConfig
  children: ReactNode
}) => (
  <SharedAuthProvider
    config={config}
    callerPath={CALLER_PATH}
    redirectPath={REDIRECT_PATH}
  >
    {children}
  </SharedAuthProvider>
)

export const useAuth = () => useSharedAuth<Caller, PortalConfig>()
